import LabelProvider from "core/components/label/LabelProvider";

export default LabelProvider.create({

    HideCourses:{
        k: "track.collapse.hide",
        v: "Hide Courses"
    },
    ShowCourses:{
        k: "track.collapse.show",
        v: "Show Courses"
    },
    LaunchCourse:{
        k:"course.launch",
        v:"Launch Course"
    }
});


// WEBPACK FOOTER //
// ./src/panels/tracksProgram/TracksProgram.labels.ts